import { create } from 'zustand'
import type { Band } from '@/api/types'

export type Lens = 'table' | 'treemap' | 'sunburst' | 'heatmap' | 'graph'

// Persona presets — each composes a default lens (+ filter) over the same
// persona-agnostic API (design §5.8, P4). Switching persona requires no backend call.
export interface Persona {
  key: string
  label: string
  lens: Lens
  band?: Band | ''
}

export const PERSONAS: Persona[] = [
  { key: 'all', label: 'Complete', lens: 'table' },
  { key: 'secmgr', label: 'Security Manager', lens: 'table' },
  { key: 'ciso', label: 'CISO', lens: 'treemap' },
  { key: 'inventory_owner', label: 'Inventory Owner', lens: 'sunburst' },
  { key: 'compliance', label: 'Compliance', lens: 'heatmap' },
  { key: 'auditor', label: 'Auditor', lens: 'graph' },
]

interface ViewState {
  lens: Lens
  band: Band | ''
  persona: string
  setLens: (lens: Lens) => void
  setBand: (band: Band | '') => void
  applyView: (v: { lens?: Lens; band?: Band | '' }) => void
  applyPersona: (key: string) => void
}

// Drives the Assets multi-lens view. Set by lens tabs, saved profiles, or persona switch.
export const useViewStore = create<ViewState>((set) => ({
  lens: 'table',
  band: '',
  persona: 'all',
  setLens: (lens) => set({ lens }),
  setBand: (band) => set({ band }),
  applyView: (v) => set((s) => ({ lens: v.lens ?? s.lens, band: v.band ?? s.band })),
  applyPersona: (key) => {
    const p = PERSONAS.find((x) => x.key === key)
    if (p) set({ persona: key, lens: p.lens, band: p.band ?? '' })
  },
}))
